var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoAcescoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1066.63 223.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .e {\n        fill: #2e3c54;\n      }\n\n      .e, .f {\n        stroke-width: 0px;\n      }\n\n      .f {\n        fill: url(#d);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    "data-name": "New Gradient Swatch 1",
    x1: 149.94,
    y1: 233.53,
    x2: 149.94,
    y2: -4.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2ab4f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14daa0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M448.58,156.85h-45.98l-8.81,19.86h-29.8l54.79-112.94h13.62l54.95,112.94h-29.8l-8.97-19.86ZM412.69,133.46h25.79l-12.98-28.19-12.82,28.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M575.77,138.27l21.95,18.42c-11.05,13.3-27.87,21.47-46.78,21.47-33,0-59.91-25.79-59.91-57.83s26.91-57.99,59.91-57.99c18.9,0,35.72,8.33,46.78,21.63l-21.95,18.42c-5.45-8.33-14.58-13.62-24.83-13.62-16.66,0-30.44,11.85-30.44,31.56s13.78,31.56,30.44,31.56c10.25,0,19.38-5.29,24.83-13.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M705.54,152.69v24.03h-89.55V63.78h86.19v24.03h-58.63v22.43h48.7v23.39h-48.7v19.06h62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M813.35,142.28c0,22.59-17.78,36.04-44.69,36.04-19.87,0-30.44-1.92-48.38-10.89l10.25-21.47c14.26,6.73,25.79,8.17,39.09,8.17,9.61,0,15.06-3.2,15.06-9.29,0-5.29-4.97-8.49-20.51-12.02-23.55-5.45-42.29-11.69-42.29-35.08,0-20.66,16.34-35.4,42.93-35.4,18.42,0,33,4.65,44.53,9.29l-11.53,22.27c-10.09-4-23.55-7.37-33.8-7.37-8.81,0-13.46,3.68-13.46,8.81,0,5.77,5.45,8.65,21.31,12.17,25.31,5.45,41.49,13.62,41.49,34.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M913.31,138.27l21.95,18.42c-11.05,13.3-27.88,21.47-46.78,21.47-33,0-59.91-25.79-59.91-57.83s26.91-57.99,59.91-57.99c18.9,0,35.72,8.33,46.78,21.63l-21.95,18.42c-5.45-8.33-14.58-13.62-24.83-13.62-16.66,0-30.44,11.85-30.44,31.56s13.78,31.56,30.44,31.56c10.25,0,19.38-5.29,24.83-13.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1066.63,120.33c0,32.04-26.91,57.83-60.23,57.83s-60.39-25.79-60.39-57.83,27.07-57.99,60.39-57.99,60.23,25.95,60.23,57.99ZM1037.63,120.33c0-17.46-13.94-31.72-31.24-31.72s-31.24,14.26-31.24,31.72,13.94,31.72,31.24,31.72,31.24-14.1,31.24-31.72Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M227.31,80.39c-3.39-6.71-10.28-10.94-17.8-10.94h-57.79L187,0h-61.14c-7.52,0-14.4,4.23-17.8,10.94L0,223.67h61.14c7.52,0,14.4-4.23,17.8-10.94l71.11-139.99,70.9,139.99c3.4,6.71,10.28,10.94,17.8,10.94h61.14l-72.58-143.29Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAcescoColor);
export default __webpack_public_path__ + "static/media/Logo_Acesco_Color.b27f50e7e0fc9d6fffc653282ac107ee.svg";
export { ForwardRef as ReactComponent };